// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .customer-clustering .form{
display: flex;
flex-wrap: wrap;
justify-content: space-between;
}
.customer-clustering .form .ant-select,
    .customer-clustering .form .ant-input{
    width: 32%;
} */
.customer-clustering .ant-row {
  margin: 0 !important;
  /* padding: 0 0.313rem; */
}
.customer-clustering .graph-card {
  margin: 2.5rem 0;
  margin-top: 0;
}
.customer-clustering h2 {
  margin: 1.875rem 0;
  text-align: center !important;
  letter-spacing: 0.063rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/customerClustering.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;AACH;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B","sourcesContent":["/* .customer-clustering .form{\ndisplay: flex;\nflex-wrap: wrap;\njustify-content: space-between;\n}\n.customer-clustering .form .ant-select,\n    .customer-clustering .form .ant-input{\n    width: 32%;\n} */\n.customer-clustering .ant-row {\n  margin: 0 !important;\n  /* padding: 0 0.313rem; */\n}\n.customer-clustering .graph-card {\n  margin: 2.5rem 0;\n  margin-top: 0;\n}\n.customer-clustering h2 {\n  margin: 1.875rem 0;\n  text-align: center !important;\n  letter-spacing: 0.063rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
